export const manifesto: string[] = [
    'Pixels began as a private folder — the handful of sections we kept rebuilding for clients because nothing off the shelf was good enough to steal. Four years of that folder, and the pattern was obvious. The scenes people remembered were never the ones with the most going on. They were the ones that answered back.',
    'So the studio is built around one refusal: we do not ship volume. There is no library of four hundred blocks here, because four hundred blocks is a warehouse, not a point of view. Each scene is a full build — real geometry, real physics, real restraint — and it goes in only once it can hold a page on its own.',
    'The work is deliberately plain underneath. Readable files, exposed tokens, no runtime to install and nothing phoning home. You take a scene, make it unrecognisably yours, and never think about us again. That is the whole idea.'
]

export const principles = [
    {
        title: 'One at a time',
        body: 'A section ships when it is undeniable, not when the calendar says so. Some months that means one scene. Some months it means none, and we say so.'
    },
    {
        title: 'Motion with a reason',
        body: 'Springs, velocity, cursor forces, a live clock. If the movement cannot answer to the visitor, it is decoration — and decoration gets cut before it reaches you.'
    },
    {
        title: 'Nothing generic',
        body: 'No particle fields, no dot grids, no gradient text. If a model could sneeze it out at three in the morning, it never makes it into the library.'
    },
    {
        title: 'Yours to keep',
        body: 'Every scene you take is yours for good. Restyle it, rewrite it, tear it apart. There is no expiry date on work you have already paid for.'
    }
]

export const process = [
    {
        step: 'Pick a scene',
        body: 'Browse the library and take what fits. Everything arrives as plain, readable files with the palette exposed as tokens at the top.'
    },
    {
        step: 'Make it yours',
        body: 'Swap the copy, retune the colours, move the geometry. Nothing is locked behind a build step, a licence key or a dashboard.'
    },
    {
        step: 'Ship it',
        body: 'Drop it into the page and it runs. No runtime to install, no account for your visitors to trip over, no third-party script in the head.'
    },
    {
        step: 'Keep going',
        body: 'New scenes land as they are finished, and the library quietly grows underneath you for as long as you stay.'
    }
]

export const ledger = [
    { value: '60fps', label: 'On a mid-range laptop' },
    { value: 'Zero', label: 'Image assets shipped' },
    { value: '1.3s', label: 'To assemble on load' },
    { value: '2026', label: 'Studio established' }
]
